import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, CHANNELS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'channel',
  url: `${CHANNELS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
